import { UserPermissions } from '../../../../../enums';

export const assessmentRoutes = [
    {
        path: '',
        name: 'ManageAssessments',
        component: () => import('@/products/pha/modules/assessment/views/ManageAssessment.vue'),
        meta: {
            breadcrumb: [{ parent: 'Assessment', label: 'All Assessments' }],
            requiresAuth: true,
            permission: [UserPermissions.READ_ASSESSMENT],
        },
    },
    {
        path: 'config-steps/:id',
        name: 'AssessmentStepsAndLinksConfig',
        props: true,
        component: () => import('../views/AssessmentStepsAndLinksConfig.vue'),
        meta: {
            breadcrumb: [{ parent: 'Assessment', label: 'Configure Assessment Steps' }],
            requiresAuth: true,
            permission: [UserPermissions.WRITE_ASSESSMENT],
        },
    },
];
